// THE TRIBUTE RAMP — pure rules (no timers, no DOM). The running tally idles at a flat IDLE rate (TributeRamp.idlePerSec, +1 m/s);
// while the player rapid-clicks, the rules-based income — citizen wages, educated citizens, rice paddies, commercial plots — ramps
// IN over rampUpMs, and eases back out over rampDownMs once the clicking stops. rate = idle + active × ramp.
// Tests: scripts/qa/tribute.test.mjs.

export const emptyRamp = () => 0

// The ramp (0…1) after dtMs more time: up while clicking is rapid, down when it is not.
export function stepRamp(ramp, rapid, dtMs, cfg) {
  const d = rapid ? dtMs / cfg.rampUpMs : -dtMs / cfg.rampDownMs
  return Math.max(0, Math.min(1, ramp + d))
}
// The tribute rate in m/s before the global multipliers (federation, events, tax bonus…).
export const tributeRate = (idle, active, ramp) => idle + active * Math.max(0, Math.min(1, ramp))
